import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const TrackSource = () => {
    const location = useLocation();

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);

        const gadSource = searchParams.has("gad_source");
        const gclid = searchParams.has("gclid");
        const source = searchParams.has("source");
        const sourceValue = searchParams.get("source");

        const currentTime = new Date().getTime();
        const storedTime = sessionStorage.getItem("timestamp");
        const FIFTEEN_DAYS_MS = 15 * 24 * 60 * 60 * 1000;

        if (storedTime && currentTime - storedTime < FIFTEEN_DAYS_MS) {
            return;
        }

        const leadFlag = gadSource || gclid || source ? "Paid" : "Organic";

        sessionStorage.setItem("lead_flag", leadFlag);
        sessionStorage.setItem("timestamp", currentTime);
        sessionStorage.setItem("source_value", sourceValue);
    }, [location.search]);

    return null;
};

export default TrackSource;